// extracted by mini-css-extract-plugin
export default {"wrapper":"BNwQo9IaRDlzWdm6KM5l"};